import { Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function HomeSecondSection() {
  const [date, setDate] = useState(new Date());
  const {t} = useTranslation();
  useEffect(() => {
    const id = setInterval(() => {
      setDate(new Date());
    }, 1000);
    return () => clearInterval(id);
  }, [])
  return (
    <div className="grow flex flex-col items-end max-w-none md:max-w-sm">
      <div className="flex flex-row gap-2 w-full  items-center py-10">
        <div className="rounded-lg opacity-40 bg-green-50 grow h-0.5" />
        <Typography className="text-primary-contrastText">{date.toLocaleString('fa-IR')}</Typography>
        <div className="rounded-lg opacity-40 bg-green-50 grow h-0.5" />
      </div>
      <div className="flex flex-row gap-2.5 w-full">
        <Button component={Link} to='/car/new' className="h-14 bg-primary-contrastText grow px-10" variant="text">{t('submit_car')}</Button>
        <Button component={Link} to='/report' className="grow px-10" color="secondary" variant="contained">{t('reports')}</Button>
      </div>
    </div>
  )
}
